import { Injectable } from '@angular/core';
import { BehaviorSubject} from 'rxjs';

@Injectable()
export class DarkMode{
    // toDark:boolean=false;
    // public toDarkSubject = new BehaviorSubject<boolean>(this.toDark);
    themeMode: ThemeMode = ThemeMode.LightMode;
    public themeModeSubject = new BehaviorSubject<ThemeMode>(this.themeMode);
  
    setThemeMode(mode: ThemeMode) {
      this.themeMode = mode;
      this.themeModeSubject.next(this.themeMode);
    }
  
    getThemeMode(): ThemeMode {
      return this.themeMode;
    }

}
export enum ThemeMode{
    LightMode = "lightMode",
    DarkMode = "darkMode"
}


// WEBPACK FOOTER //
// /src/providers/dark-mode/dark-mode.ts